import _defineProperty from '@babel/runtime/helpers/defineProperty';
import formatPrice from '@bwoty-web/price-formatter';
import { isSameDay, isBefore, isWithinInterval } from 'date-fns';
import { Week, WeekNrCell, BlankCell, Day, DayCell, RecommendedIndicator, OfferContainer, DayOffer } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var directFlightIcon =
// eslint-disable-next-line max-len
'M37.2652 3.26517C37.4116 3.11872 37.4116 2.88128 37.2652 2.73483L34.8787 0.34835C34.7322 0.201903 34.4948 0.201903 34.3483 0.34835C34.2019 0.494796 34.2019 0.732233 34.3483 0.87868L36.4697 3L34.3483 5.12132C34.2019 5.26777 34.2019 5.5052 34.3483 5.65165C34.4948 5.7981 34.7322 5.7981 34.8787 5.65165L37.2652 3.26517ZM4 3.375H37V2.625H4V3.375Z';
var isInSelectedInterval = function isInSelectedInterval(dateStr, selectedDateInterval) {
  if (!(selectedDateInterval.from || selectedDateInterval.to)) {
    return false;
  }
  var date = new Date(dateStr);
  try {
    return isWithinInterval(date, {
      start: new Date(selectedDateInterval.from),
      end: new Date(selectedDateInterval.to)
    });
  } catch (e) {
    return false;
  }
};
var MonthRow = function MonthRow(_ref) {
  var _ref$weekNumber = _ref.weekNumber,
    weekNumber = _ref$weekNumber === void 0 ? '1' : _ref$weekNumber,
    _ref$weekDays = _ref.weekDays,
    weekDays = _ref$weekDays === void 0 ? [] : _ref$weekDays,
    _ref$selectedDay = _ref.selectedDay,
    selectedDay = _ref$selectedDay === void 0 ? '' : _ref$selectedDay,
    onSelectDay = _ref.onSelectDay,
    _ref$selectedDateInte = _ref.selectedDateInterval,
    selectedDateInterval = _ref$selectedDateInte === void 0 ? {} : _ref$selectedDateInte,
    _ref$monthIsSelected = _ref.monthIsSelected,
    monthIsSelected = _ref$monthIsSelected === void 0 ? false : _ref$monthIsSelected,
    _ref$useDynamicRangeS = _ref.useDynamicRangeSelect,
    useDynamicRangeSelect = _ref$useDynamicRangeS === void 0 ? false : _ref$useDynamicRangeS,
    _ref$setDateHovered = _ref.setDateHovered,
    setDateHovered = _ref$setDateHovered === void 0 ? function () {} : _ref$setDateHovered,
    _ref$dateHovered = _ref.dateHovered,
    dateHovered = _ref$dateHovered === void 0 ? null : _ref$dateHovered,
    _ref$dynamicRangeInPr = _ref.dynamicRangeInProgress,
    dynamicRangeInProgress = _ref$dynamicRangeInPr === void 0 ? false : _ref$dynamicRangeInPr,
    _ref$offers = _ref.offers,
    offers = _ref$offers === void 0 ? [] : _ref$offers,
    _ref$datePickerHasOff = _ref.datePickerHasOffers,
    datePickerHasOffers = _ref$datePickerHasOff === void 0 ? false : _ref$datePickerHasOff,
    _ref$datePickerHasSel = _ref.datePickerHasSelectedMonths,
    datePickerHasSelectedMonths = _ref$datePickerHasSel === void 0 ? false : _ref$datePickerHasSel,
    _ref$recommendedDates = _ref.recommendedDates,
    recommendedDates = _ref$recommendedDates === void 0 ? [] : _ref$recommendedDates,
    siteId = _ref.siteId;
  if (weekDays.length !== 7) {
    throw new TypeError('WeekDays must be 7 days long');
  }
  var dayMouseEnter = function dayMouseEnter(day) {
    if (dynamicRangeInProgress) {
      setDateHovered(day);
    }
  };
  return /*#__PURE__*/jsxs(Week, {
    children: [/*#__PURE__*/jsx(WeekNrCell, {
      $datePickerHasOffers: datePickerHasOffers,
      children: weekNumber
    }), weekDays.map(function (day, i) {
      if (!day) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          jsx(BlankCell, {
            children: /*#__PURE__*/jsx(Day, {
              as: "div"
            })
          }, "empty-".concat(i))
        );
      }
      var isSelected = selectedDay && selectedDay === day.fullDate;
      var dayOffer = offers === null || offers === void 0 ? void 0 : offers.find(function (offer) {
        return isSameDay(new Date(offer.day), new Date(day.fullDate));
      });
      var inRange = isInSelectedInterval(day.fullDate, selectedDateInterval) || isInSelectedInterval(day.fullDate, {
        from: selectedDateInterval.from,
        to: dateHovered
      });
      var isRangeStart = isSameDay(new Date(day.fullDate), new Date(selectedDateInterval.from));
      var isRangeEnd = isSameDay(new Date(day.fullDate), new Date(selectedDateInterval.to)) || isSameDay(new Date(day.fullDate), new Date(dateHovered)) && !isRangeStart;
      var isBeforeRangeStart = isBefore(new Date(day.fullDate), new Date(selectedDateInterval.from));
      var isDisabled = dynamicRangeInProgress && (isBeforeRangeStart || isRangeStart) || day.disabled;
      var isRecommended = !useDynamicRangeSelect && recommendedDates.includes(day.fullDate);
      var styleProps = {
        $datePickerHasOffers: datePickerHasOffers,
        $datePickerHasSelectedMonths: datePickerHasSelectedMonths,
        $dynamicRangeInProgress: dynamicRangeInProgress,
        $inRange: inRange,
        $isDisabled: isDisabled,
        $isRangeEnd: isRangeEnd,
        $isRangeStart: isRangeStart,
        $isRecommended: isRecommended,
        $isSelected: isSelected,
        $monthIsSelected: monthIsSelected,
        $useDynamicRangeSelect: useDynamicRangeSelect
      };
      return /*#__PURE__*/jsxs(DayCell, _objectSpread(_objectSpread({
        onMouseEnter: function onMouseEnter() {
          return !isDisabled && dayMouseEnter(day.fullDate);
        },
        onFocus: function onFocus() {
          return !isDisabled && dayMouseEnter(day.fullDate);
        },
        onClick: function onClick(e) {
          return !isDisabled && onSelectDay(e, day.fullDate);
        }
      }, styleProps), {}, {
        children: [/*#__PURE__*/jsx(Day, _objectSpread(_objectSpread({
          "aria-disabled": isDisabled,
          "aria-label": day.fullDate,
          "data-date": day.fullDate,
          type: "button"
        }, styleProps), {}, {
          children: day.date
        })), !dayOffer && isRecommended && /*#__PURE__*/jsx(RecommendedIndicator, {
          children: "\u2022"
        }), dayOffer && /*#__PURE__*/jsxs(OfferContainer, {
          children: [dayOffer.price && /*#__PURE__*/jsx(DayOffer, {
            isCheapest: dayOffer.isCheapest,
            children: formatPrice(dayOffer.price, siteId)
          }), dayOffer.isDirectFlight && /*#__PURE__*/jsxs("svg", {
            width: "38",
            height: "6",
            viewBox: "0 0 38 6",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [/*#__PURE__*/jsx("path", {
              d: directFlightIcon,
              fill: "#454545"
            }), /*#__PURE__*/jsx("circle", {
              cx: "2.5",
              cy: "3",
              r: "2.125",
              fill: "white",
              stroke: "#454545",
              strokeWidth: "0.75"
            })]
          })]
        })]
      }), day.date);
    })]
  });
};
var MonthRow$1 = MonthRow;

export { MonthRow$1 as default };
//# sourceMappingURL=MonthRow.js.map
